import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

export default function Header({
  logo = "",
  invertLogo = "",
  title,
  stepConf,
  invert = false,
}) {
  const progress = stepConf && (stepConf.current / stepConf.max) * 100;
  const showSteps =
    stepConf &&
    stepConf.max > 0 &&
    stepConf.current >= (stepConf.displayAfter || stepConf.max / 2);

  const dHeaderInfoClassName = classnames("d_header_info", {
    has_progressbar: progress !== undefined,
  });

  const mHeaderInfoClassName = classnames("m_header_info", {
    has_progressbar: progress !== undefined,
  });

  const wgaHeaderClassName = classnames("wga-header", {
    has_progressbar: progress !== undefined && showSteps,
    "wga-header--inverted": invert,
  });

  const logoSrc = invert ? invertLogo : logo;

  return (
    <div className={wgaHeaderClassName}>
      {logoSrc ? <img src={logoSrc} alt={title} /> : <h1>{title}</h1>}

      {showSteps && (
        <>
          <span className={dHeaderInfoClassName}>
            Ya solo quedan <big>{stepConf.max - stepConf.current}</big> preguntas
          </span>
          <span className={mHeaderInfoClassName}>
            <span className="m_header_info_before" />

            {`${stepConf.current}/${stepConf.max}`}
            <span
              className="m_header_info_after"
              style={{
                width: `${135 * (progress / 100)}px`,
                right: `calc(1rem + 135px - ${135 * (progress / 100)}px`,
              }}
            />
          </span>
        </>
      )}
      <span
        className="m_header_after"
        style={{
          width: `${progress}%`,
        }}
      />
    </div>
  );
}

Header.propTypes = {
  logo: PropTypes.string,
  invertLogo: PropTypes.string,
  invert: PropTypes.bool,
  title: PropTypes.string.isRequired,
  stepConf: PropTypes.shape({
    current: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    displayAfter: PropTypes.number,
  }),
};
